export default "__VITE_ASSET__BBnExOXV__"